import React, { useEffect, useState } from "react";
import Button from "../components/Buttons/Button";
import Swal from "sweetalert2";
import Datatable from "../components/tables/Datatable";
import Loader from "../components/Loader";

const columns = [
  {
    header: "ID",
    accessor: "id",
  },
  {
    header: "Country Name",
    accessor: "country_name",
  },
];

const AddCountry = () => {
  const [addCountry, setAddCountry] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);

  // 🔥 pagination state
  const [page, setPage] = useState(1);
  const [entries, setEntries] = useState(5);

  useEffect(() => {
    const timer = setTimeout(() => setInitialLoad(false), 500);
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!addCountry.trim()) {
      setError("Country name is required");
      return;
    }

    setError("");

    try {
      setLoading(true);
      await Swal.fire({
        title: "Success!",
        text: "New Country Added!",
        icon: "success",
      });
      setAddCountry("");
    } finally {
      setLoading(false);
    }
  };

  // ✅ static data
  const staticCountries = [
    { id: 1, country_name: "India" },
    { id: 2, country_name: "USA" },
    { id: 3, country_name: "Canada" }, 
  ];

  // 🔥 pagination logic
  const totalPages = Math.ceil(staticCountries.length / entries);

  const paginatedData = staticCountries.slice(
    (page - 1) * entries,
    page * entries,
  );

  if (initialLoad) return <Loader />;

  return (
    <section className="mx-auto px-4 bg-gray-50">
      {/* FORM */}
      <div className="w-full max-w-7xl bg-white rounded-2xl border border-gray-200 shadow-sm p-8">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-gray-900">Add Country</h1>
          <p className="text-gray-500 text-sm mt-1">
            Provide details to create a new country.
          </p>
        </div>

        <form className="space-y-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end">
            <div className="flex flex-col flex-1">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Country Name
              </label>

              <input
                value={addCountry}
                onChange={(e) => {
                  setAddCountry(e.target.value);
                  if (error) setError("");
                }}
                placeholder="Type country name..."
                className={`w-full rounded-lg px-4 py-3 border ${
                  error
                    ? "border-red-500"
                    : addCountry.trim()
                      ? "border-green-500"
                      : "border-gray-300"
                }`}
              />
            </div>

            <Button
              text={loading ? "Saving..." : "Add country"}
              disable={loading}
              onClick={handleSubmit}
              classes="w-full sm:w-[180px] md:w-[300px] py-3"
            />
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}
        </form>
      </div>

      {/* TABLE */}
      <div className="w-full max-w-7xl bg-white rounded-2xl border border-gray-200 shadow-sm p-8 mt-12">
        <Datatable
          title="Country List"
          columns={columns}
          data={paginatedData}
          isloading={false}
          paginationInfo={{
            currentPage: page,
            totalPages: totalPages,
            entriesPerPage: entries,
            onPageChange: (p) => setPage(p),
            onEntriesChange: (val) => {
              setEntries(val);
              setPage(1);
            },
          }}
        />
      </div>
    </section>
  );
};

export default AddCountry;
